// extracted by mini-css-extract-plugin
module.exports = {"container":"jobListing-module--container--2z_sR","date":"jobListing-module--date--2IV8Y"};